import _ from '@/utils/lodash-optimized'
import { useState } from 'react'

import { capitalize } from '../../../../igao/utils'
import { PlainButton } from '../../../../shared/Button'
import { Divider } from '../../../../shared/Divider'
import { Button, PortedModal } from '../../../../shared/NarusMaterial'
import Issue from '../issue/Issue'

import styles from './edit-item.module.scss'

const transformIssue = ({ description, domain, goal, id }) => {
  return {
    comment: [],
    actions: [],
    createdAt: new Date().toISOString(),
    description,
    details: [],
    domain,
    goal,
    relations: [],
    id
  }
}

const StaticItem = ({
  item,
  applyChanges,
  setEditableQuestion,
  items
}) => {
  const [ editable, setEditable ] = useState(_.cloneDeep(item))
  const [ modal, setModal ] = useState(null)

  const handleChange = (key, value) => {
    setEditable(prev => ({
      ...prev,
      [key]: value
    }))
  }

  const equalItem = _.isEqual(editable, item)

  const onCancel = () => {
    if (equalItem) {
      setEditableQuestion(null)
      setEditable(null)
      return
    }
    setModal({
      title:
        'It looks like you have been editing something. If you leave before saving, your changes will be lost.',
      open: true,
      actions: [
        <Button
          key={1}
          label='Cancel'
          onClick={() => {
            setModal(null)
          }}
          grey
        />,
        <Button
          key={2}
          label='Discard'
          onClick={() => {
            setEditableQuestion(null)
            setEditable(null)
            setModal(null)
          }}
        />
      ]
    })
  }

  let disableButton
  if (!equalItem) {
    if (item.type === 'label') {
      disableButton = editable?.label?.length <= 0
    } else {
      disableButton =
        items.some(i => i.type === 'header' && i.label === editable?.label) ||
        editable?.label?.length <= 0
    }
  } else disableButton = true

  return (
    <div className={styles.editableContainer}>
      <label htmlFor='label'>
        {editable?.type && capitalize(editable?.type === 'other' ? 'label' : editable?.type)}
      </label>
      <input
        type='text'
        name='label'
        value={editable?.label}
        onChange={e => handleChange('label', e.target.value)}
      />
      <div className={styles.bottomContainer}>
        <div>
          Item ID:
          {editable?.id}
        </div>
        <div className={styles.buttons}>
          <PlainButton
            label='Cancel'
            onClick={onCancel}
          />
          <PlainButton
            label='Save'
            style={{ marginLeft: '12px' }}
            disabled={disableButton}
            btnType='contained'
            color='primary'
            onClick={() => applyChanges(editable)}
          />
        </div>
      </div>
      {item.conditions && (
        <div style={{ marginTop: '20px' }}>
          <Divider />
          <div style={{ marginTop: '10px' }}>
            {item.conditions.map(c => (
              <>
                <Issue
                  key={c.id}
                  issue={transformIssue(c)}
                />
                <Divider />
              </>
            ))}
          </div>
        </div>
      )}
      <PortedModal
        open={modal?.open}
        title={modal?.title}
        actions={modal?.actions}
      />
    </div>
  )
}

export default StaticItem
